import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import HowItWorks from "@/components/site/HowItWorks";
import Services from "@/components/site/Services";
import TreatmentMenu from "@/components/site/TreatmentMenu";
import Stats from "@/components/site/Stats";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";

export default function Home() {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Services />
        <TreatmentMenu />
        <Stats />
        <Process />
        <WhyChooseUs />
        <About />
        <Testimonials />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
